import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import * as R from 'ramda'

const config = require('../../config')

function SEO({ description, lang, meta, keywords, title }) {
    const metaDescription = description || config.description
    
    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: config.title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: config.author,
                },
                {
                    name: `twitter:title`,
                    content: config.title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ]
                .concat(
                    keywords.length > 0
                        ? {
                              name: `keywords`,
                              content: keywords.join(`, `),
                          }
                        : []
                )
                .concat(meta)}
            title={title}
            // titleTemplate={`${config.title} | %s `}
            titleTemplate={
                !R.isNil(title) && title != "" && title != 'Home' 
                    ? `${title} | ${config.title}` 
                    : `${config.title}`
            }
        >
            <meta http-equiv="X-Content-Type-Options" content="nosniff"/>
            <meta http-equiv="X-XSS-Protection" content="1; mode=block"/>
            <meta http-equiv="Cache-Control" content="no-cache"/>
            <meta http-equiv="Expires" content="0"/>
            <meta http-equiv="Pragma" content="no-cache"/>

            {process.env.env_name !== 'production' ? null : (
                <>
                    <meta http-equiv="set-cookie" content="Secure; SameSite=None"/>
                    <meta http-equiv="Content-Security-Policy" data-react-helmet="true" content="upgrade-insecure-requests; default-src 'self' 'unsafe-inline' 'unsafe-eval' *.jquery.com *.zeus.go.kr *.google-analytics.com *.googleapis.com *.google.com *.googletagmanager.com *.kakao.com *.gstatic.com *.youtube.com data: *.jsdelivr.net localhost:* ws://localhost:* *.seoulbiohub.kr *.www.seoulbiohub.kr https://www.seoulbiohub.kr/*"/>
                    <meta http-equiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains; preload"/>
                </>
            )}
        </Helmet>
    )
}

SEO.defaultProps = {
    lang: config.lang,
    keywords: [],
    meta: [],
}

SEO.propTypes = {
    description: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string),
    lang: PropTypes.string,
    meta: PropTypes.array,
    title: PropTypes.string.isRequired,
}

export default SEO
